<div class="flamingo-grid-flat-table-container" *ngIf="(success$ | async) || (pageLoading$ | async)">
  <mode-flat-table-ng
    *ngIf="(content$ | async)?.length"
    [columns]="columns$ | async"
    [content]="content$ | async"
    [executionTime]="executionTime"
    [expandableCellContents]="true"
    [isFallbackData]="isFallbackData"
    [fieldFormats]="fieldFormats$ | async"
    [flatSorting]="false"
    [format]="format$ | async"
    [lastSuccessfulLabel]="lastSuccessfulLabel"
    [lastSuccessfulRunAt]="lastSuccessfulRunAt"
    [paging]="paging$ | async"
    [resizableColumns]="true"
    [size]="size"
    [token]="queryToken"
    (offsetChange)="setOffset($event)"
    (renderEnd)="renderEnd()"
  ></mode-flat-table-ng>
</div>
<div *ngIf="failed$ | async">
  <mode-flamingo-error-ng
    [csvLink]="csvLink"
    [errorResponse]="flamingoError$ | async"
    (notebookSelected)="goToNotebook()"
  ></mode-flamingo-error-ng>
</div>
<div *ngIf="loading$ | async">
  <mode-table-loading></mode-table-loading>
</div>
